var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 87,
    viewBox: "0 0 80 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.1938 9.56023L65.1094 17.5722C63.7791 18.8906 61.7324 18.8906 60.4021 17.5722C59.0717 16.2537 59.0717 14.2254 60.4021 12.907L68.4864 4.89506C69.8167 3.57665 71.8634 3.57665 73.1938 4.89506C74.4218 6.21348 74.4218 8.34323 73.1938 9.56023Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5016 3.12961V7.62179C54.5016 9.3796 52.9999 10.7468 51.0692 10.7468C49.1384 10.7468 47.6367 9.3796 47.6367 7.62179V3.12961C47.6367 1.3718 49.1384 0.00461714 51.0692 0.00461714C52.8926 -0.093039 54.5016 1.3718 54.5016 3.12961Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.859 30.2881H72.3498C70.5853 30.2881 69.2129 28.7921 69.2129 26.8686C69.2129 24.9452 70.5853 23.4492 72.3498 23.4492H76.859C78.6235 23.4492 79.9959 24.9452 79.9959 26.8686C80.094 28.7921 78.6235 30.2881 76.859 30.2881Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M63.7951 85.1366L48.856 71.0894C48.7798 71.0134 48.7798 70.9375 48.856 70.8616L52.8957 66.5335C52.9719 66.4576 53.0481 66.4576 53.1243 66.5335L68.0635 80.5808C69.3592 81.7957 69.3592 83.7699 68.2159 84.9848C66.9964 86.2756 65.0146 86.3515 63.7951 85.1366Z",
    fill: "#CAD1D8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M29.3447 79.7483C45.5513 79.7483 58.6894 66.66 58.6894 50.5148C58.6894 34.3695 45.5513 21.2812 29.3447 21.2812C13.1381 21.2812 0 34.3695 0 50.5148C0 66.66 13.1381 79.7483 29.3447 79.7483Z",
    fill: "#CAD1D8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0744 79.9687L52.1353 65.9214C52.0591 65.8455 52.0591 65.7696 52.1353 65.6936L56.175 61.3655C56.2512 61.2896 56.3274 61.2896 56.4036 61.3655L71.3427 75.4128C72.6385 76.6277 72.6385 78.6019 71.4952 79.8168C70.3519 81.1076 68.2939 81.1836 67.0744 79.9687Z",
    fill: "#CAD1D8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.624 74.5764C48.8306 74.5764 61.9687 61.4881 61.9687 45.3429C61.9687 29.1977 48.8306 16.1094 32.624 16.1094C16.4174 16.1094 3.2793 29.1977 3.2793 45.3429C3.2793 61.4881 16.4174 74.5764 32.624 74.5764Z",
    fill: "#CAD1D8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6236 67.7486C45.0416 67.7486 55.1085 57.7199 55.1085 45.3489C55.1085 32.9779 45.0416 22.9492 32.6236 22.9492C20.2055 22.9492 10.1387 32.9779 10.1387 45.3489C10.1387 57.7199 20.2055 67.7486 32.6236 67.7486Z",
    fill: "white",
    fillOpacity: 0.95
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchError);
export default __webpack_public_path__ + "static/media/searchError.29df9c39be55d9b123d7300ebced93df.svg";
export { ForwardRef as ReactComponent };